
enum TypeViz {
    Pagetype = 'Pagetype',
    Url = 'Url',
}
enum OrderBy {
  SessionCount = 'SessionCount',
  ConvertedSessionCount = 'ConvertedSessionCount',
  Turnover = 'Turnover',
  ConversionRate = 'ConversionRate',
  ExitRate = 'ExitRate'
}

interface DatavizualizationSettings {
  type: TypeViz;
  startDate: string; 
  endDate?: string;
  orderBy: OrderBy;
  orderByAsc: boolean;
  maxDepth: number;
  maxBranchesAtFirstDepth: number;
  branchesDeclineFactor: number;
}
interface ApiResponseMinAndMaxDates {
  minStartDate: string; 
  maxEndDate: string;
  maxAllowedDaysToRequest: number;
}

interface TrafficSource {
  id: string;
  count: number;
}

interface VisEngLevel {
  d: string;
  count: number;
}

interface NextStep {
  VisEngLevels: VisEngLevel[];
  convertedSessionCount: number;
  id: string;
  pageTypes: null | string[]; 
  sessionCount: number;
  nextSteps: NextStep[];
  turnover: number;
  trafficSources: TrafficSource[];
    topUrls: {
    id: string;
    count: number;
  }
}

interface JourneyData {
  endDate: string;
  journeyType: string;
  startDate: string;
  starts: NextStep[];
  totalConvertedSessionCount: number;
  totalSessionCount: number;
  totalTurnover: number;


}
type VisitorEngagementLevel = 'X' // Lost
	| 'C' // Consideration
	| 'D' // Discover
	| 'I' // Intention
	| 'A' // Purchase
	| 'E' // Experience
	| 'R' // Recurring purchase
	| 'none'; // None

type PageTypes = 'H' | 'C' | 'FP' | 'B' | 'T' | 'G' | 'O'; 

export { 
	DatavizualizationSettings,
	TypeViz,
	OrderBy,
	ApiResponseMinAndMaxDates,
	JourneyData,
	VisitorEngagementLevel,
	PageTypes,
	
};